import { t } from "i18next";
import { z } from "zod";

export const upsertDiligenceSchema = () =>
  z.object({
    name: z.string().min(1, t("global.form.error.mandatoryField")),
  });

export type UpsertDiligenceFormValues = z.infer<ReturnType<typeof upsertDiligenceSchema>>;
